import React, { memo, useMemo } from 'react'
import tw from 'twin.macro'
import { GSIcon } from 'src/components/shared/GSIcon'
import { RowActionsMenu } from 'src/components/shared/grid/RowActionsMenu'
import type { AiDocumentReviewConfig } from 'src/interfaces/aiDocumentReviewConfig'
import type { MenuActionItem } from 'src/interfaces/ui'

interface Props {
  config: AiDocumentReviewConfig
  onEdit(config: AiDocumentReviewConfig): void
  onDelete(config: AiDocumentReviewConfig): void
}

const AiReviewConfigActionsCellComponent = ({ config, onEdit, onDelete }: Props) => {
  const items = useMemo<MenuActionItem[]>(() => {
    return [
      {
        label: 'Edit',
        icon: <GSIcon iconName="gs_pencil" size={20} css={tw`text-shades-1000`} />,
        dataTestId: `ai-review-configs-edit-${config.id}`,
        onClick: () => {
          onEdit(config)
        },
      },
      {
        label: 'Delete',
        icon: <GSIcon iconName="gs_trash_can" size={20} css={tw`text-critical-500`} />,
        color: 'var(--mui-critical-500)',
        dataTestId: `ai-review-configs-delete-${config.id}`,
        onClick: () => {
          onDelete(config)
        },
      },
    ]
  }, [config, onEdit, onDelete])

  return (
    <RowActionsMenu
      items={items}
      ariaLabel="AI review configuration actions"
      dataTestId={`ai-review-configs-actions-${config.id}`}
    />
  )
}

export const AiReviewConfigActionsCell = memo(AiReviewConfigActionsCellComponent)
